import {lazy} from 'react';

const loadOnBoardingPage = () => import('./OnBoardingPage');
export const OnBoardingPageLoad = lazy(loadOnBoardingPage);
